//トップページ　キービジュアルスライダー


export function idxFunc() {

}
